import React from 'react';
import PropTypes from 'prop-types';

/**
 * Error component with centered message
 * Used when session initialization fails
 */
const ErrorScreen = ({ message }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      width: '100%',
      backgroundColor: '#0f172a',
      padding: '20px',
    }}
  >
    <div
      style={{
        maxWidth: '500px',
        width: '100%',
        backgroundColor: '#1e293b',
        border: '1px solid #334155',
        borderRadius: '12px',
        padding: '32px',
        textAlign: 'center',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)',
      }}
    >
      {/* Error icon */}
      <div
        style={{
          width: '64px',
          height: '64px',
          margin: '0 auto 24px',
          backgroundColor: '#991b1b',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fca5a5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>

      {/* Error title */}
      <h2
        style={{
          fontSize: '24px',
          fontWeight: '700',
          color: '#f1f5f9',
          margin: '0 0 12px',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        Session Error
      </h2>

      {/* Error message */}
      <p
        style={{
          fontSize: '16px',
          color: '#cbd5e1',
          margin: '0 0 24px',
          lineHeight: '1.6',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        {message || 'Unable to initialize session. Please try refreshing the page.'}
      </p>

      {/* Reload button */}
      <button
        onClick={() => window.location.reload()}
        style={{
          backgroundColor: '#EF4444',
          color: '#ffffff',
          border: 'none',
          borderRadius: '8px',
          padding: '12px 24px',
          fontSize: '16px',
          fontWeight: '600',
          cursor: 'pointer',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          transition: 'background-color 0.2s',
        }}
        onMouseOver={(e) => (e.target.style.backgroundColor = '#DC2626')}
        onMouseOut={(e) => (e.target.style.backgroundColor = '#EF4444')}
      >
        Reload Page
      </button>
    </div>
  </div>
);

ErrorScreen.propTypes = {
  message: PropTypes.string,
};

export default ErrorScreen;
